import { Injectable } from '@angular/core';

const ACCESS_KEY = 'passwordExpiredAccess';
const USERNAME_KEY = 'passwordExpiredUserName';

// Habilita el acceso a /psw-expired solo cuando el login detecto la contraseña vencida,
// y guarda el mail ingresado para enviarlo como userName al cambiar la contraseña.
// Usa sessionStorage para sobrevivir un refresh sin persistir entre pestañas/sesiones.
@Injectable({
  providedIn: 'root'
})
export class PasswordExpiredAccessService {

  grantAccess(userName?: string): void {
    this.setItem(ACCESS_KEY, 'true');
    if (userName) {
      this.setItem(USERNAME_KEY, userName);
    }
  }

  clearAccess(): void {
    this.removeItem(ACCESS_KEY);
    this.removeItem(USERNAME_KEY);
  }

  hasAccess(): boolean {
    return this.getItem(ACCESS_KEY) === 'true';
  }

  getUserName(): string {
    return this.getItem(USERNAME_KEY) ?? '';
  }

  private getItem(key: string): string | null {
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  }

  private setItem(key: string, value: string): void {
    try {
      sessionStorage.setItem(key, value);
    } catch {
      // sessionStorage no disponible, el acceso dura solo esta navegacion.
    }
  }

  private removeItem(key: string): void {
    try {
      sessionStorage.removeItem(key);
    } catch {
      // ignorado
    }
  }
}
